export default "__VITE_ASSET__DvRfyio___"